import React from 'react';
import { Section } from '../../src';
class SelectTest extends React.Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <div >
        下拉框测试
        <Section />
      </div>
    )
  }
}
export default SelectTest;



// WEBPACK FOOTER //
// ./example/select_test/index.js